export default "__VITE_ASSET__CVfZceKj__"